import React, { useEffect, useState } from 'react'
// import BlockUi from 'react-block-ui';
// import 'react-block-ui/style.css';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
    useLocation,
    useNavigate
} from "react-router-dom";

import useForm from "../../services/useForm";
import validate from "../../services/validations/loginFormValidationRules";


import { HeaderPrivate } from '../../components/HeaderPrivate'
import { PrivateTitleBar } from '../../components/PrivateTitleBar'
import { PrivateFooter } from '../../components/PrivateFooter'
import { DashboardNav } from '../../components/DashboardNav'

export const PrivateProfile = () => {
    const {
        values,
        errors,
        handleChange,
        handleSubmit,
        setData
    } = useForm(updatePersonalInfo, validateProfile);

    // const history = useHistory();
    const location = useLocation();
    const [userName, setUserName] = useState('');
    const [hasAccess, setHasAccess] = useState(false);
    const [hasErrors, setHasErrors] = useState(false);
    const [errorMessages, setErrorMessages] = useState('');
    const [success, setSuccess] = useState(false);

    function showDefaultError() {
        setErrorMessages('Ha ocurrido un error inesperado, por favor vuelva a intentarlo más tarde.')
        setHasErrors(true);
    }

    function validateProfile(values) {
        let errors = {};

        if (!values.name) {
            errors.name = 'El nombre es requerido';
        }

        if (!values.surname) {
            errors.surname = 'El apellido es requerido';
        }

        if (!values.email) {
            errors.email = 'El email es requerido';
        } else if (!/\S+@\S+\.\S+/.test(values.email)) {
            errors.email = 'Por favor, escribe un email válido';
        }

        return errors;
    };


    useEffect(() => {
        let kwt = sessionStorage.getItem('kwt');

        if (!!kwt) {
            fetch(process.env.REACT_APP_API_URL + "/users/profile", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + kwt
                }
            })
                .then((response) => {
                    if (response.ok) {
                        response.json().then(data => {
                            setHasAccess(true);
                            setData(data);
                            setUserName(data.name)
                        });
                    }
                    else {
                        sessionStorage.removeItem('kwt');
                        window.location = "/";
                    }
                })
                .catch(function (error) {
                    showDefaultError();
                });
        }
    }, []);


    function updatePersonalInfo() {
        setSuccess(false)
        setHasErrors(false)
        setErrorMessages('')
        let kwt = sessionStorage.getItem('kwt');
        
        fetch(process.env.REACT_APP_API_URL + "/users/updateProfile", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + kwt
            },
            body: JSON.stringify(
                {
                    user: values
                })
        })
            .then((response) => {
                if (response.ok) {
                    setSuccess(true);
                }
                else {
                    if (response.status === 500) {
                        showDefaultError();
                    }
                    else {
                        showDefaultError();
                    }
                }
            })
            .catch(function (error) {
                showDefaultError();
            });
    }
    return (
        <>
            {hasAccess &&
                <>
                    <HeaderPrivate userName={values.userName} avatar={values.avatar} />
                    <div id="dashboard">
                        <a href="#" className="dashboard-responsive-nav-trigger"><i className="fa fa-reorder"></i> Menú</a>
                        <DashboardNav selectedMenu="profile" />

                        <div className="dashboard-content">

                            <PrivateTitleBar title="Mi perfil" />

                            <div className="row">

                                {/* <!-- Profile --> */}
                                <form onSubmit={handleSubmit} className="register">
                                    <div className="col-lg-6 col-md-12">
                                        <div className="dashboard-list-box margin-top-0">
                                            <h4 className="gray">Datos Personales</h4>
                                            <div className="dashboard-list-box-static">

                                                {/* <!-- Avatar --> */}
                                                <div className="edit-profile-photo">
                                                    <img src={values.avatar ? values.avatar : 'images/user-avatar.jpg'} alt="" />
                                                    <div className="change-photo-btn">
                                                        <div className="photoUpload">
                                                            <span><i className="fa fa-upload"></i> Cambiar foto</span>
                                                            <input type="file" className="upload" />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* <!-- Details --> */}
                                                <div className="my-profile">

                                                    <label for="name">Nombres:</label>
                                                    <input type="text" className="input-text" name="name" onChange={handleChange} value={values.name || ''} />
                                                    {errors.name && (
                                                        <p className="help is-danger">{errors.name}</p>
                                                    )}

                                                    <label for="surname">Apellidos: </label>
                                                    <input type="text" className="input-text" name="surname" onChange={handleChange} value={values.surname || ''} />
                                                    {errors.surname && (
                                                        <p className="help is-danger">{errors.surname}</p>
                                                    )}


                                                    <label for="email">Email: </label>
                                                    <input type="email" className="input-text" name="email" onChange={handleChange} value={values.email || ''} />
                                                    {errors.email && (
                                                        <p className="help is-danger">{errors.email}</p>
                                                    )}

                                                    <label for="location">Localidad:</label>
                                                    <select className="chosen-select" name="location" onChange={handleChange} value={values.location || ''} >
                                                        <option>Selecciona la localidad</option>
                                                        <option>A Coruña</option>
                                                        <option>Alicante</option>
                                                        <option>Albacete</option>
                                                        <option>Almería</option>
                                                        <option>Asturias</option>
                                                        <option>Ávila</option>
                                                        <option>Badajoz</option>
                                                        <option>Barcelona</option>
                                                        <option>Bizkaia</option>
                                                        <option>Burgos</option>
                                                        <option>Cáceres</option>
                                                        <option>Cádiz</option>
                                                        <option>Cantabria</option>
                                                        <option>Castelló</option>
                                                        <option>Ceuta</option>
                                                        <option>Ciudad Real</option>
                                                        <option>Córdoba</option>
                                                        <option>Cuenca</option>
                                                        <option>Gipuzkoa</option>
                                                        <option>Girona</option>
                                                        <option>Granada</option>
                                                        <option>Guadalajara</option>
                                                        <option>Huelva</option>
                                                        <option>Huesca</option>
                                                        <option>Islas Baleares</option>
                                                        <option>Jaén</option>
                                                        <option>La Rioja</option>
                                                        <option>Las Palmas</option>
                                                        <option>León</option>
                                                        <option>Lleida</option>
                                                        <option>Lugo</option>
                                                        <option>Madrid</option>
                                                        <option>Málaga</option>
                                                        <option>Melilla</option>
                                                        <option>Murcia</option>
                                                        <option>Nafarroa</option>
                                                        <option>Ourense</option>
                                                        <option>Palencia</option>
                                                        <option>Pontevedra</option>
                                                        <option>Salamanca</option>
                                                        <option>Segovia</option>
                                                        <option>Sevilla</option>
                                                        <option>Soria</option>
                                                        <option>Sta. Cruz de Tenerife</option>
                                                        <option>Tarragona</option>
                                                        <option>Teruel</option>
                                                        <option>Toledo</option>
                                                        <option>Valéncia</option>
                                                        <option>Valladolid</option>
                                                        <option>Zamora</option>
                                                        <option>Zaragoza</option>
                                                    </select>

                                                    <label for="street">Dirección:</label>
                                                    <input type="text" className="input-text" name="street" onChange={handleChange} value={values.street || ''} />

                                                    <label for="streetExtra">Dirección (Información extra):</label>
                                                    <input type="text" className="input-text" name="streetExtra" onChange={handleChange} value={values.streetExtra || ''} />

                                                    <label for="postalCode">Código Postal:</label>
                                                    <input type="text" className="input-text" name="postalCode" onChange={handleChange} value={values.postalCode || ''} />

                                                    <label for="phoneNumber">Teléfono</label>
                                                    <input type="text" className="input-text" name="phoneNumber" onChange={handleChange} value={values.phoneNumber || ''} />

                                                    <label for="birthday">Fecha de Nacimiento:</label>
                                                    <input type="date" className="input-text" name="birthday" onChange={handleChange} value={values.birthday || ''} />
                                                </div>
                                                <input type="submit" className="button margin-top-15" name="savePersonalInfo" value="Guardar" />
                                            </div>
                                        </div>
                                    </div>
                                </form>

                                <div className="col-lg-6 col-md-12">
                                    <div className="dashboard-list-box margin-top-0">
                                        <h4 className="gray">Contacto de emergencia</h4>
                                        <div className="dashboard-list-box-static">

                                            <div className="my-profile">
                                                <label className="margin-top-0">Contacto</label>
                                                <input value={values.emergencyContact1} type="text" />

                                                <label className="margin-top-0">Téléfono Contacto</label>
                                                <input value={values.emergencyContactPhone1} type="text" />

                                                <button className="button margin-top-15">Guardar contacto</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dashboard-list-box margin-top-0">
                                        <h4 className="gray">Cambiar tu contraseña</h4>
                                        <div className="dashboard-list-box-static">

                                            <div className="my-profile">
                                                <label className="margin-top-0">Contraseña actual</label>
                                                <input type="password" />

                                                <label className="margin-top-0">Nueva contraseña</label>
                                                <input type="password" />

                                                <label className="margin-top-0">Reingrese la nueva contraseña</label>
                                                <input type="password" />

                                                <button className="button margin-top-15">Cambiar contraseña</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <PrivateFooter />
                            </div>
                        </div>
                        {/* <!-- Content / End --> */}
                    </div>
                </>
            }
        </>
    )
}